__turbopack_context__.v({
  "button": "styles-module-scss-module__1otHya__button",
  "button__show": "styles-module-scss-module__1otHya__button__show",
});
